import React, { useEffect, useState } from "react";
import OurStory from "../../../assets/our-story-image.jpg";
import BoxBackground from "../../../assets/get-demo-box-bg.jpg";
import { Link } from "react-router-dom";

const OurStoryMissionSection = ({ acfData }) => {
  const [ourStoryData, setOurStoryData] = useState({
    our_story_title: "Our Story",
    our_story_description:
      "We've booked millions of tours, consulted 4000 room Las Vegas hotels, developed software that generates over $100 million in revenue, built IT infrastructure for dozens of hotels and founded three successful startups.\r\n\r\nWe've experienced firsthand hospitality staff becoming burned out by subpar technology. Seen hotels and tours get hit with surprise charges and hidden fees. Scrambled because supposedly secure systems were compromised or crashed.\r\n\r\nWe've also grown up on the Rez. We've seen far too much poverty, far too few Native entrepreneurs and small business owners, and far too many tourism dollars leaving Indian Country.\r\n\r\nSuffice it to say, we've seen enough.",
    our_story_button_text: "Read More",
    our_story_button_url: "/about-us",
    our_story_image: OurStory,
    our_mission_section_title: "Our Mission",
    our_mission_section_title_description:
      "Boosting the Indigenous economy by keeping more tourism, retail and hospitality dollars on Indigenous land.",
  });

  useEffect(() => {
    if (acfData) {
      const {
        our_story_title,
        our_story_description,
        our_story_button_text,
        our_story_button_url,
        our_story_image,
        our_mission_section_title,
        our_mission_section_title_description,
      } = acfData;
      setOurStoryData((prev) => ({
        ...prev,
        our_story_title: our_story_title || "Our Story",
        our_story_description:
          our_story_description ||
          "We've booked millions of tours, consulted 4000 room Las Vegas hotels, developed software that generates over $100 million in revenue, built IT infrastructure for dozens of hotels and founded three successful startups.\r\n\r\nWe've experienced firsthand hospitality staff becoming burned out by subpar technology. Seen hotels and tours get hit with surprise charges and hidden fees. Scrambled because supposedly secure systems were compromised or crashed.\r\n\r\nWe've also grown up on the Rez. We've seen far too much poverty, far too few Native entrepreneurs and small business owners, and far too many tourism dollars leaving Indian Country.\r\n\r\nSuffice it to say, we've seen enough.",
        our_story_button_text: our_story_button_text || "Read More",
        our_story_button_url:
          our_story_button_url || "/about-us",
        our_story_image: our_story_image || OurStory,
        our_mission_section_title: our_mission_section_title || "Our Mission",
        our_mission_section_title_description:
          our_mission_section_title_description || "Boosting the Indigenous economy by keeping more tourism, retail and hospitality dollars on Indigenous land.",
      }));
    }
  }, [acfData]);

  const renderHTML = (content) => {
    return <div dangerouslySetInnerHTML={{ __html: content }} />;
  };

  // Function to render paragraphs as <p> tags and remove empty lines
  const renderParagraphs = (content) => {
    const paragraphs = content
      .split("\r\n") // Split by newlines
      .filter((para) => para.trim() !== "") // Remove empty lines
      .map((para, idx) => (
        <p
          key={idx}
          className="text-lg font-light leading-7 text-[#333333] mb-3"
        >
          {para}
        </p>
      ));
    return paragraphs;
  };

  return (
    <>
      <section className="py-14 lg:pt-20 lg:pb-24 bg-[#F7F7F7]">
        <div className="w-full max-w-[1570px] px-4 mx-auto">
          <div className="flex flex-wrap items-center -mx-4 lg:gap-y-11">
            <div className="w-full lg:w-1/3 max-w-full px-4">
              <div
                className="flex flex-col gap-y-6 items-start p-8 sm:py-10 sm:px-12 lg:min-w-[781px] rounded-t-[21px] lg:rounded-[21px] shadow-[0_7px_27px_0px_rgba(0,0,0,0.08)] relative"
                style={{
                  backgroundImage: `url(${BoxBackground})`,
                }}
              >
                <h3 className="text-[30px] md:text-[40px] lg:text-[52px] font-normal leading-tight text-[#5fa3b2]">
                  {ourStoryData?.our_story_title}
                </h3>
                <div>
                  {(ourStoryData?.our_story_description || "").includes("<")
                    ? renderHTML(ourStoryData?.our_story_description || "")
                    : renderParagraphs(
                        ourStoryData?.our_story_description || ""
                      )}
                </div>
                <Link
                  to={ourStoryData?.our_story_button_url || "#"}
                  className="text-lg font-bold leading-6 text-[#5FA3B2] bg-[transparent] border border-[#5FA3B2] py-[17px] px-[35px] rounded-xl transition-all ease-in-out duration-500 hover:text-white hover:bg-[#5FA3B2] "
                >
                  {ourStoryData?.our_story_button_text || "Read More"}
                </Link>
              </div>
            </div>
            <div className="w-full lg:w-2/3 max-w-full px-4">
              <img
                src={ourStoryData?.our_story_image || OurStory}
                alt="OurStory"
                className="w-full lg:max-w-[840px] lg:ml-auto rounded-b-[21px] lg:rounded-[21px]"
                height="841"
                width="663"
              />
            </div>
            <div className="w-full max-w-full px-4 mt-8 lg:mt-0">
              <div className="max-w-[750px] mx-auto text-center">
                <h3 className="text-[30px] md:text-[40px] lg:text-[52px] font-normal leading-tight text-[#5fa3b2] mb-4">
                  {ourStoryData?.our_mission_section_title || "Our Mission"}
                </h3>
                <p className="text-xl md:text-2xl font-medium leading-8 text-[#111111] italic">
                  {ourStoryData?.our_mission_section_title_description ||
                    "Boosting the Indigenous economy by keeping more tourism, retail, and hospitality dollars on Indigenous land."}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OurStoryMissionSection;
